import apiService from '@/services/api/YachtSalesSlots'

const STATUS_OPEN = 'open'
const STATUS_CLOSED = 'closed'
const STATUS_EXPIRED = 'expired'
const STATUS_RESERVED = 'reserved'
const STATUS_SOLD = 'sold'

const emptyFilters = {
  id: null,
  yard_id: null,
  yacht_model: null,
  status: 'open',
  ex_factory_year: null,
  note: null
}

const emptyModel = {
  id: null,
  yard_id: null,
  yacht_manufacturer_id: null,
  yacht_model: null,
  status: null,
  ex_factory_date: null,
  last_order_date: null,
  note: null
}

const STATUS_DATA = {
  [STATUS_OPEN]: {
    color: 'grey darken-1',
    hexColor: '#757575',
    label: 'Open',
    key: STATUS_OPEN
  },
  [STATUS_CLOSED]: {
    color: 'red',
    hexColor: '#F44336',
    label: 'Closed',
    key: STATUS_CLOSED
  }
  // [STATUS_EXPIRED]: {
  //   color: 'red',
  //   hexColor: '#F44336',
  //   label: 'Expired',
  //   key: STATUS_EXPIRED
  // },
  // [STATUS_RESERVED]: {
  //   color: 'brown',
  //   hexColor: '#795548',
  //   label: 'Reserved',
  //   key: STATUS_RESERVED
  // },
  // [STATUS_SOLD]: {
  //   color: 'primary',
  //   hexColor: '#2196f3',
  //   label: 'Sold',
  //   key: STATUS_SOLD
  // }
}

export default new class YachtSalesSlot {
  constructor() {
    this.api = apiService
    this.emptyModel = emptyModel
    this.emptyFilters = emptyFilters
    this.statusData = STATUS_DATA

    this.STATUS_OPEN = STATUS_OPEN
    this.STATUS_CLOSED = STATUS_CLOSED
    this.STATUS_EXPIRED = STATUS_EXPIRED
    this.STATUS_RESERVED = STATUS_RESERVED
    this.STATUS_SOLD = STATUS_SOLD
  }

  allStatuses() {
    return Object.keys(this.statusData).map((key) => {
      return {
        text: this.statusData[key].label,
        value: key
      }
    })
  }
}()
